import React, { useState } from 'react';
import '../components/PriceCalculator.css';
import '../pages/Projects.css';
import PriceCalculator from '../components/PriceCalculator';

const Freelance = () => {
    const freelanceProjects = [
        {
            id: 11,
            title: "House Springs Coin Laundry",
            description: "Freelance website for House Springs Coin Laundry featuring modern design and responsive layout. Includes business hours, services (self-service laundry, wash dry fold, dry cleaning drop-off), facility information, and contact details.",
            technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
            githubUrl: null,
            liveUrl: "http://housespringscoinlaundry.com/",
            image: "laundry-icon",
            category: "Freelance",
            subcategory: "Freelance Project"
        },
        {
            id: 9,
            title: "Twin City Coin Laundry",
            description: "Freelance website for Twin City Coin Laundry featuring modern design and responsive layout. Includes business hours, services (self-service laundry, wash dry fold, dry cleaning drop-off), facility information, and contact details.",
            technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
            githubUrl: null,
            liveUrl: "https://www.segotw.com/laundries/twincitycoinlaundry/",
            image: "laundry-icon",
            category: "Freelance",
            subcategory: "Freelance Project"
        },
        {
            id: 10,
            title: "Sudsy's Coin Laundry",
            description: "Freelance website for Sudsy's Coin Laundry featuring modern design and responsive layout. Includes business hours, services (self-service laundry, wash dry fold, dry cleaning drop-off, ironing), facility information, and contact details.",
            technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
            githubUrl: null,
            liveUrl: "https://sudsyslaundromat.com/",
            image: "laundry-icon",
            category: "Freelance",
            subcategory: "Freelance Project"
        },
        {
            id: 12,
            title: "InterState Coin Laundry",
            description: "Freelance website made for a customer of System Engineering Group. Features modern design and responsive layout for a professional laundromat business.",
            technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
            githubUrl: null,
            liveUrl: "https://interstatecoinlaundry.com/",
            image: "laundry-icon",
            category: "Freelance",
            subcategory: "Freelance Project"
        },
        {
            id: 7,
            title: "Weinrich Construction",
            description: "A website for a small business construction company built during my first semester of college using HTML, CSS, and JavaScript. Features modern design and responsive layout for a professional construction business.",
            technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
            githubUrl: null,
            liveUrl: "https://weinrichconstructionstl.com/",
            image: "construction-icon",
            category: "Freelance",
            subcategory: "Freelance Project"
        },
        {
            id: 13,
            title: "One Call Services STL",
            description: "Freelance website for One Call Services STL. Features modern design and responsive layout for a professional handyman and construction business.",
            technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
            githubUrl: null,
            liveUrl: "https://onecallservicesstl.com/",
            image: "construction-icon",
            category: "Freelance",
            subcategory: "Freelance Project"
        }
    ];

    const [expandedProject, setExpandedProject] = useState(null);

    return (
        <div className="projects">
            <div className="container">
                <section className="projects-hero">
                    <h1 className="section-title">Freelance Projects</h1>
                    <p className="projects-intro">
                        Custom web solutions for small businesses.
                    </p>
                </section>

                <section className="projects-grid">
                    {freelanceProjects.map(project => (
                        <div
                            key={project.id}
                            className={`project-card ${project.isPrized ? 'prized-project' : ''}`}
                            data-project-id={project.id}
                        >
                            <div className="project-image">
                                {project.image === "laundry-icon" ? (
                                    <svg className="project-icon custom-svg" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 4H15C15 4.39397 14.9224 4.78407 14.7716 5.14805C14.6209 5.51203 14.3999 5.84274 14.1213 6.12132C13.8427 6.3999 13.512 6.62087 13.1481 6.77164C12.7841 6.9224 12.394 7 12 7C11.606 7 11.2159 6.9224 10.8519 6.77164C10.488 6.62087 10.1573 6.3999 9.87868 6.12132C9.6001 5.84274 9.37913 5.51203 9.22836 5.14805C9.0776 4.78407 9 4.39397 9 4H6L3 7L3.5 12L6 10.5M21 7L20.5 12L18 10.5V20H6V14" stroke="white" strokeWidth="1.5" fill="none" />
                                    </svg>
                                ) : project.image === "construction-icon" ? (
                                    <svg className="project-icon custom-svg" viewBox="0 -0.5 17 17" fill="none">
                                        <path d="M15.287,12.025 L13.274,12.025 L12.746,10.025 L3.176,10.025 L2.648,12.025 L0.692,12.025 C0.322,12.025 0.021,12.296 0.021,12.634 L0.021,13.318 C0.021,13.655 0.322,13.927 0.692,13.927 L15.288,13.927 C15.658,13.927 15.959,13.655 15.959,13.318 L15.959,12.634 C15.958,12.297 15.657,12.025 15.287,12.025 L15.287,12.025 Z" fill="white" />
                                        <path d="M10.207,0.031 L5.797,0.031 L5.038,2.952 L10.969,2.952 L10.207,0.031 Z" fill="white" />
                                        <path d="M11.346,5.004 L4.658,5.004 L4.021,7.955 L11.984,7.955 L11.346,5.004 Z" fill="white" />
                                    </svg>
                                ) : (
                                    <span className={`project-icon`}>{project.image}</span>
                                )}
                            </div>

                            <div className="project-content">
                                <div className="project-header">
                                    <h3 className="project-title">{project.title}</h3>
                                </div>

                                <div className="project-categories">
                                    <span className="project-category">{project.category}</span>
                                    <span className="project-subcategory">{project.subcategory}</span>
                                </div>

                                <p className="project-description">{project.description}</p>

                                <div className="project-technologies">
                                    {project.technologies.map(tech => (
                                        <span key={tech} className="tech-tag">{tech}</span>
                                    ))}
                                </div>

                                <div className="project-links">
                                    {project.liveUrl && (
                                        <a
                                            href={project.liveUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="project-link live-link"
                                        >
                                            <span>🌐</span> View Site
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </section>

                <section className="freelance-tools-section">
                    <PriceCalculator />
                </section>

                <section className="projects-cta">
                    <div className="cta-content">
                        <h2>Want to discuss a project?</h2>
                        <a href="mailto:JacobW@segotw.com" className="btn btn-primary">
                            Contact Me
                        </a>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Freelance;
